const autoMessages = (state = {}, {type, payload}) => {
  switch (type) {
    case 'AUTO_MESSAGES.INIT':
      return {...state, ...payload}
    default:
      return state
  }
}

export default autoMessages
